import { createContext, useContext, useMemo, useState } from 'react'

const GameSettingsContext = createContext({
  rounds: 5,
  setRounds: () => {},
  modeLabel: 'solo',
  setModeLabel: () => {},
})

export function GameSettingsProvider({ children }) {
  const [rounds, setRounds] = useState(5)
  const [modeLabel, setModeLabel] = useState('solo')
  const value = useMemo(
    () => ({ rounds, setRounds, modeLabel, setModeLabel }),
    [rounds, modeLabel],
  )
  return <GameSettingsContext.Provider value={value}>{children}</GameSettingsContext.Provider>
}

export function useGameSettings() {
  return useContext(GameSettingsContext)
}
